const MuiPaper = {
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.background.default
            })
    }
};
export { MuiPaper };

//# sourceMappingURL=paper.js.map